import { Navigate } from "react-router";
import { useAuth } from "../hooks/auth.hooks";

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string; // optional, defaults to dashboard
}

export function PublicRoute({ children, redirectTo = "/dashboard" }: PublicRouteProps) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
